module.exports = __webpack_public_path__ + "img/traversees.918991d6.png";